import * as React from "react";
import { createRoot } from "react-dom/client";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import { ThemeProvider } from "@fluentui/react";
import { HashRouter } from "react-router-dom";
import { Provider } from "react-redux";
import App from "./App";
import store from "./store/index";
import ConfigService from "./shared/services/configService";
import "./index.scss";
import { TEXT } from "./shared/constants/texts";
import "./fabric.min.css";
import "./font-awesome.min.css";

initializeIcons();

const configService = new ConfigService();
let isOfficeInitialized = false;

const title = TEXT.OUTLOOK_TITLE;
const rootElement: HTMLElement = document.getElementById("container");
const root = createRoot(rootElement);

if (typeof Promise.allSettled !== "function") {
  Promise.allSettled = function (promises) {
    return Promise.all(
      promises.map(
        (promise) =>
          new Promise((resolve) => {
            Promise.resolve(promise).then(
              (value) => resolve({ status: "fulfilled", value }),
              (reason) => resolve({ status: "rejected", reason })
            );
          })
      )
    );
  };
}

declare global {
  interface PromiseConstructor {
    withResolvers<T>(): {
      promise: Promise<T>;
      resolve: (value: T | PromiseLike<T>) => void;
      reject: (reason?: any) => void;
    };
  }
}

if (typeof Promise.withResolvers === "undefined") {
  Promise.withResolvers = function <T>() {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: any) => void;
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

const render = (Component) => {
  root.render(
    <Provider store={store}>
      <HashRouter>
        <ThemeProvider>
          <Component title={title} isOfficeInitialized={isOfficeInitialized} />
        </ThemeProvider>
      </HashRouter>
    </Provider>
  );
};

Office.initialize = async () => {
  await configService.getTaskpaneConfigData();
  isOfficeInitialized = true;
  render(App);
};

if ((module as any).hot) {
  (module as any).hot.accept("./App", () => {
    const NextApp = require("./App").default;
    render(NextApp);
  });
}
